import React from 'react'
import { Switch, Route } from 'react-router-dom'

import DebugPanel from './DebugPanel'
import CardRegistrationCompleted from './containers/CardRegistrationCompleted'
import NormalCardInput from './containers/NormalCardInput'
import RedCardInput from './containers/RedCardInput'
import GreenCardInput from './containers/GreenCardInput'
import SelectCard from './containers/SelectCard'
import RegisteredCard from './containers/RegisteredCard'
import StoreRegistrationCompleted from './components/screens/StoreRegistrationCompleted'
import AddStore from './containers/AddStore'
import PrefectureInput from './containers/PrefectureInput'
import CityInput from './containers/CityInput'
import NearbyStoreInput from './containers/NearbyStoreInput'
import NearbyStoreGPSInput from './containers/NearbyStoreGPSInput'
import PrivacyPolicy from './containers/PrivacyPolicy'
import QuestionAndAnswer from './containers/QuestionAndAnswer'
import RegisteredStoreList from './containers/RegisteredStoreList'
import RedirectRichMenu from './containers/RedirectRichMenu'
import LineAccountPartnerInfo from './components/screens/LineAccountPartnerInfo'
import Maintenance from './components/screens/Maintenance'
import EventsList from './containers/EventsList'
import EndedEventsList from './containers/EndedEventsList'
import EventDetail from './containers/EventDetail'
import ServiceDetail from './containers/ServiceDetail'
import TopCampaign from './containers/TopCampaign'

const needsToShowDebugPanel = process.env.REACT_APP_NEEDS_TO_SHOW_DEBUG_PANEL === 'true'

export default function Routes() {
  return (
    <Switch>
      <Route path="/select-card" component={SelectCard} />
      <Route path="/normal-card-input" component={NormalCardInput} />
      <Route path="/red-card-input" component={RedCardInput} />
      <Route path="/green-card-input" component={GreenCardInput} />
      <Route path="/card-registration-completed/:storeRegist" component={CardRegistrationCompleted} />
      <Route path="/add-store" component={AddStore} />
      <Route path="/prefecture-input" component={PrefectureInput} />
      <Route path="/nearby-store-input/:prefectureCd?" component={NearbyStoreInput} />
      <Route path="/nearby-store-gps" component={NearbyStoreGPSInput} />
      <Route path="/store-registration-completed" component={StoreRegistrationCompleted} />
      <Route path="/registered-store-list" component={RegisteredStoreList} />
      <Route path="/registered-card" component={RegisteredCard} />
      <Route path="/question-and-answer/:answerId?" component={QuestionAndAnswer} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/city-input/:prefectureCd" component={CityInput} />
      <Route path={["/Menu/:type", "/Page/:type"]} component={RedirectRichMenu} />
      <Route path="/line-account-partner" component={LineAccountPartnerInfo} />
      <Route path="/events" exact component={EventsList} />
      <Route path="/ended-events" component={EndedEventsList} />
      <Route path="/events/:eventId" component={EventDetail} />
      <Route path="/service-detail" component={ServiceDetail} />
      <Route path="/maintenance" component={Maintenance} />
      <Route path="/top-campaign" component={TopCampaign} />
      <Route
        path="/"
        render={() => {
          if (needsToShowDebugPanel) {
            return <DebugPanel />
          } else {
            return null
          }
        }}
      />
    </Switch>
  )
}
